import useLocations from './useLocations';

export default useLocations;
